export enum OpenBankingAutoConnectModalSteps {
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
  ConnectionFailed = 'connection_failed',
}
